/**
 * Checks if `value` is not `undefined` or `null`
 *
 * @param value
 * @returns
 * @example
 *
 * isDefined(undefined) -> false
 * isDefined(null) -> false
 * isDefined('any') -> true
 * isDefined(1) -> true
 * isDefined(true) -> true
 */
export function isDefined<T = unknown>(value: T): value is NonNullable<T> {
  return value !== undefined && value !== null;
}
